import queries from '@apis/queries';
import useLocation from '@hooks/native/useLocation';
import useTestUser from '@hooks/test/useTestUser';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';

function useNearShop() {
    const { data: user, status } = useQuery(queries.user.detail());
    const [lat, setLat] = useState(0);
    const [lon, setLon] = useState(0);
    const { data: shops } = useQuery({
        ...queries.shop.list({
            page: 0,
            size: 20,
            locationAgreed: true,
            searchType: 'ORDER',
            lat,
            lon,
        }),
        enabled: lat !== 0 && lon !== 0,
    });
    const isTestUser = useTestUser();

    useLocation({
        deps: [user, status],
        enabled: status !== 'pending' && (user?.locationAgreed || !user),
        callbackFn: ({ lat: newLat, lon: newLon }) => {
            setLat(newLat);
            setLon(newLon);
        },
    });

    return useMemo(() => {
        function isWithin2km(distanceStr: string): boolean {
            const trimmed = distanceStr.replace(/ /gi, '').toLowerCase();
            const match = trimmed.match(/^(\d+(\.\d+)?)(m|km)$/);
            if (!match) {
                throw new Error(`Invalid distance format: ${distanceStr}`);
            }
            const value = parseFloat(match[1]);
            const unit = match[3];
            const meters = unit === 'km' ? value * 1000 : value;
            return meters <= 2000;
        }

        if (shops) {
            const openShops = shops.content
                .filter((shop) => {
                    if (shop.isTestShop && !isTestUser) {
                        return false;
                    }
                    const { distanceFromUser } = shop;
                    return isWithin2km(distanceFromUser) && shop.orderStatus === 'OPEN';
                });
            return openShops?.[0];
        }
        return undefined;
    }, [shops, isTestUser]);
}

export default useNearShop;
